import axios from "axios";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL = "/logo.png";
export const FAVICON_URL = "/icons/favicon-64.png?v=2";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
// Sessione morta (token invalidato server-side): pulisci e torna al login, conservando la destinazione.
api.interceptors.response.use((r) => r, (err) => {
  const st = err.response?.status;
  // Gating legale: accettazione pendente -> pagina consenso, conservando la destinazione.
  if (st === 428 && err.response?.data?.detail?.error === "legal_pending") {
    if (!window.location.pathname.startsWith("/legal/consent")) {
      const next = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/legal/consent?next=${next}`;
    }
    return Promise.reject(err);
  }
  // Account congelato (pausa/disattivazione): schermata stato account, senza logout.
  const detail = err.response?.data?.detail;
  if (st === 403 && (detail === "account_paused" || detail === "account_deactivated_requested")) {
    if (!window.location.pathname.startsWith("/account-status")) {
      window.location.href = "/account-status";
    }
    return Promise.reject(err);
  }
  // Vista embedded PAM Connect: la sessione si auto-rinnova; non reindirizzare al login dentro il Manager.
  if (st === 401 && window.location.pathname.startsWith("/pamc-embed")) {
    return Promise.reject(err);
  }
  if (st === 401 && !String(err.config?.url || "").includes("/auth/login")) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    if (!window.location.pathname.startsWith("/login")) {
      const next = encodeURIComponent(window.location.pathname + window.location.search);
      window.__ypIntentionalUnload = true;
      window.location.href = `/login?next=${next}`;
    }
  }
  return Promise.reject(err);
});

// Redirect interno sicuro: accetta solo path relativi YouPAM, blocca open redirect.
export function safeInternalPath(p) {
  if (!p || typeof p !== "string") return null;
  if (!p.startsWith("/")) return null;
  if (p.startsWith("//") || p.startsWith("/\\")) return null;
  return p;
}

export function getToken() { return localStorage.getItem("token"); }
export function setToken(t) { if (t) localStorage.setItem("token", t); else localStorage.removeItem("token"); }
export function saveUser(u) { localStorage.setItem("user", JSON.stringify(u)); }
export function getUser() { try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; } }
// Capacità clinica: Professionista sempre; Struttura solo se clinical_enabled. Non implica accesso al pregresso (serve share).
export function canClinical(u) { return u?.role === "professional" || (u?.role === "organization" && u?.clinical_enabled === true); }
// Nomenclatura unificata (R2-9): sempre "Fascicolo clinico" per Professionista e Struttura clinica.
export function clinicalLabel() { return "Fascicolo clinico"; }
// Data leggibile localizzata (IT/EN/DE/FR). Accetta ISO date o datetime; fallback alla stringa grezza.
export function fmtDate(s, lang) {
  if (!s) return "";
  const str = String(s);
  const d = new Date(str.length <= 10 ? str + "T00:00:00" : str);
  if (isNaN(d.getTime())) return str;
  try { return d.toLocaleDateString(lang || "it", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return str; }
}
export function logout() { setToken(null); localStorage.removeItem("user"); window.__ypIntentionalUnload = true; window.location.href = "/"; }
